var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-address-book fa-4x"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('rsvpDetails.systemLogs.emptyState')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11315206","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RsvpDetails/SystemLogs.vue
// module id = 1808
// module chunks = 0